import API_PATH from '@/constants/apiPath'
import Toastr from 'toastr'

const state = {
    endpoint: '',
    headerData: [['', '']],
    beforeEndpoint: '',
    beforeHeaderData: {}
}
const getters = {
}
const mutations = {
    SET_WEBHOOK_DATA (state, payload) {
        state.endpoint = payload.EndPoint
        state.headerData = Object.entries(JSON.parse(payload.CustomHeaders))
        state.beforeEndpoint = payload.EndPoint
        state.beforeHeaderData = JSON.parse(payload.CustomHeaders)
    },
    UPDATE_WEBHOOK_DATA (state, payload) {
        state.beforeEndpoint = payload.endpoint
        state.beforeHeaderData = payload.headers
    }
}
const actions = {
    async fetchWebhook ({ commit }) {
        try {
            const resp = await this.$axios.post(API_PATH.webhook.get)
            if (resp.data.EndPoint) {
                commit('SET_WEBHOOK_DATA', resp.data)
            }
        } catch (err) {
            console.log(err)
        }
    },
    async updateWebhook ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.webhook.set, payload)
            if (resp && resp.data && resp.data.displayMsg.s) {
                Toastr.success(resp.data.displayMsg.s.head, resp.data.displayMsg.s.msg)
                commit('UPDATE_WEBHOOK_DATA', payload)
            }
        } catch (err) {
            console.log(err)
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
